var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayObj.show == true)?_c('md-list-item',{on:{"click":_vm.atClick}},[(_vm.displayObj)?_c('md-icon',[_vm._v(_vm._s(_vm.displayObj.icon))]):_vm._e(),(_vm.displayObj)?_c('span',{staticClass:"md-list-item-text"},[_vm._v(_vm._s(_vm.displayObj.label))]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }